import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Checkout = () => {
    const { purchaseId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // 'success' or 'error'
    const [errorMsg, setErrorMsg] = useState('');

    const handleCheckout = async () => {
        setLoading(true);
        setStatus(null);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            const response = await fetch(`${API_BASE_URL}/portal/checkout/${purchaseId}`, {
                method: 'POST',
            });

            if (response.ok) {
                setStatus('success');
            } else {
                const data = await response.json();
                setStatus('error');
                setErrorMsg(data.detail || 'Failed to checkout. Please try again.');
            }
        } catch (error) {
            setStatus('error');
            setErrorMsg('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: 'var(--background)',
            padding: '20px'
        }}>
            <div className="glass-card" style={{ padding: '40px', maxWidth: '400px', width: '100%', textAlign: 'center' }}>
                <img src="/logo-primary.png" alt="Wagoing Logo" style={{ height: '60px', marginBottom: '20px' }} />
                
                {status === 'success' ? (
                    <div>
                        <h2 style={{ color: 'var(--success)', marginBottom: '15px' }}>Checkout Complete!</h2>
                        <p style={{ color: 'var(--text-secondary)' }}>
                            Your space has been freed. Have a great day and thanks for using Wagoing!
                        </p>
                    </div>
                ) : (
                    <div>
                        <h2 style={{ marginBottom: '20px' }}>Confirm Checkout</h2>
                        <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>
                            Click below to confirm you are leaving this parking space. Have a great day and thanks for using Wagoing!
                        </p>
                        
                        {status === 'error' && (
                            <div style={{ color: 'var(--danger)', marginBottom: '20px', fontSize: '14px' }}>
                                {errorMsg}
                            </div>
                        )}
                        
                        <button 
                            className="btn btn-primary" 
                            onClick={handleCheckout}
                            disabled={loading}
                            style={{ width: '100%', padding: '12px', fontSize: '16px' }}
                        >
                            {loading ? 'Processing...' : 'Confirm Checkout'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Checkout;
